import axios from 'lib/axios'
import {
  Benchmark,
  CategoryDataPayload,
  CompetitorAnalysisData,
  DetailedComparisonData,
  HistoryBenchmarkData
} from 'models'

const basePath = '/api/v4/benchmarks'

/* Every endpoint here answers with an empty object when the tenant has nothing benchmarked yet, so
 * each getter collapses "no benchmark" onto null/[] rather than leaking a half-filled payload. */
export const BenchmarkServiceV4 = {
  getCpiIndustryScores: async (framework: string): Promise<Benchmark | null> => {
    const { data } = await axios.get<{ benchmark?: Benchmark }>(`${basePath}/cpi_industry_scores`, {
      params: { framework }
    })
    const benchmark = data?.benchmark
    return benchmark?.score?.length ? benchmark : null
  },
  getPerformanceMetrics: async (cpiSlug: string): Promise<CompetitorAnalysisData | null> => {
    const { data } = await axios.get<{ data?: CompetitorAnalysisData }>(`${basePath}/${cpiSlug}/performance_metrics`)
    const metrics = data?.data
    return metrics?.performance_metrics?.length ? metrics : null
  },
  getScore: async (cpiSlug: string): Promise<DetailedComparisonData | null> => {
    const { data } = await axios.get<{ data?: DetailedComparisonData }>(`${basePath}/${cpiSlug}/score`)
    const score = data?.data
    return score?.score?.length ? score : null
  },
  getHistory: async (payload: CategoryDataPayload): Promise<HistoryBenchmarkData[]> => {
    const { data } = await axios.post<{ data?: HistoryBenchmarkData[] }>(`${basePath}/history`, payload)
    return data?.data ?? []
  }
}
